<lms-button-actions>
  <div class="gl-context-menu__options">
    <ng-container>
      <span *lmsProfileGuard="'subscriptions.create'" class="gl-context-menu__options--item" (click)="openModal()">
        {{ client.plan.editorAccess ? ('subscriptions.plans.edit' | translate) : ('subscriptions.create' | translate) }}
      </span>
    </ng-container>
  </div>
</lms-button-actions>

<lms-modal #modalPlanForm size="small">
  <div class="gl-modal__header">
    <div class="gl-modal__title">
      {{ 'subscriptions.plans.modalTitle' | translate }}
    </div>
    <div class="gl-modal__close" (click)="onCancel()">
      <span class="glicon-close"></span>
    </div>
  </div>
  <div>
    <lms-dynamic-form
      #dynamicForm
      [questions]="questions"
      [options]="{ disableCard: true }"
      (submit)="onSubmit($event)"
    >
      <gl-button color-secondary [text]="'actions.cancel' | translate" (onClick)="onCancel()" form-actions-before>
      </gl-button>
    </lms-dynamic-form>
  </div>
</lms-modal>
